import endpoint from "@/api/endpoint";

export default {
    all(data) {
        return window.axios.get(endpoint + '/api/projects', {params: data});
    },

    auth_all(data) {
        return window.axios.get(endpoint + '/api/auth_projects', {params: data});
    },

    byUserID(user_id) {
        return window.axios.get(endpoint + '/api/user/' + user_id + '/projects');
    },

    store(data) {
        return window.axios.post(endpoint + '/api/projects/store', data);
    },

    update(data) {
        if(data.hasOwnProperty('form_data')) return  window.axios.post(endpoint+'/api/projects/'+data.id+'/update', data.form_data);
        else return  window.axios.post(endpoint+'/api/projects/'+data.id+'/update', data);
    },

    remove(data){
        return window.axios.post(endpoint+'/api/projects/'+data.id+'/remove');
    },

    approve(data){
        return window.axios.post(endpoint+'/api/projects/'+data.id+'/approve');
    },

    decline(data){
        return window.axios.post(endpoint+'/api/projects/'+data.id+'/decline', data);
    },

    toModeration(data){
        return window.axios.post(endpoint+'/api/projects/'+data.id+'/toModeration', data);
    },
    item(data){
        return window.axios.get(endpoint+'/api/projects/'+data.id);
    },

    participants(data){
        return window.axios.get(endpoint+'/api/projects/'+data.id+'/participants');
    },

    approveParticipant(data){
        return window.axios.post(endpoint+'/api/projects/'+data.id+'/participants/'+data.user_id+'/approve');
    },

    declineParticipant(data) {
        return window.axios.post(endpoint + '/api/projects/' + data.id + '/participants/' + data.user_id + '/decline');
    },

    status(data) {
        return window.axios.get(endpoint + '/api/projects/' + data.id + '/status');
    },

    tasks(data) {
        return window.axios.get(endpoint + '/api/projects/' + data.id + '/tasks');
    },

    posts(data) {
        return window.axios.get(endpoint + '/api/projects/' + data.id + '/posts');
    },

    exams(data) {
        return window.axios.get(endpoint + '/api/projects/' + data.id + '/exams');
    },

    saveExams(data) {
        return window.axios.post(endpoint + '/api/projects/' + data.id + '/exams/'+data.exam_id, data);
    },

    enterToProject(data) {
        return window.axios.post(endpoint + '/api/projects/' + data.id + '/participants/enter', data);
    },

    includeToProject(data) {
        return window.axios.post(endpoint + '/api/projects/' + data.id + '/participants/include/'+data.user_id, data);
    },

    changeParticipantPermission(data) {
        return window.axios.post(endpoint + '/api/projects/' + data.id + '/participants/' + data.user_id + '/permission', data);
    },

    getArchiveReasons() {
        return window.axios.get(endpoint + '/api/archive_reasons');
    },

    archiveProject(data) {
        return window.axios.post(endpoint + '/api/project/' + data.id + '/archive', data);
    },

    goals(data) {
        return window.axios.get(endpoint + '/api/project/' + data.id + '/goals');
    },


}
